<div class="form-section-block" *ngIf="feederContract">
  <h2>{{ title }}</h2>
  <section>
    <h3>Erzeugungsanlage</h3>
    <p>
      <span *ngIf="feederContract.gridRegistrationType">
        {{ feederContract.gridRegistrationType | gridRegistrationTypePipe }}
      </span>
      <span *ngIf="feederContract.powerGenerationSource">
        {{ feederContract.powerGenerationSource | powerGenerationSourcePipe }}
      </span>
      <span *ngIf="feederContract.feedingPlantType">
        - {{ feederContract.feedingPlantType | feedingPlantTypeConstPipe }}
      </span>
    </p>
    <p *ngIf="feederContract.isEEGExtention">
      Erweiterung nach EEG, weil das EEG-Inbetriebnahmedatum der Bestandsanlage nicht länger als ein Jahr
      zurück liegt.
    </p>
  </section>

  <section>
    <app-display-concept
      *ngIf="feederContract.meteringConcept"
      [label]="'Messkonzept:'"
      [concept]="feederContract.meteringConcept"></app-display-concept>
  </section>

  <section>
    <app-feedin-management-summary
      [companyLocation]="feederContract.companyLocation"
      [feedInManagementInfo]="feederContract.feedInManagementInfo"
      [producers]="feederContract.producers"
      [pvModules]="feederContract.pvModules"></app-feedin-management-summary>
  </section>

  <section>
    <app-producers-summary
      [producers]="feederContract.producers"
      [consumptionOver30kw]="feederContract.consumptionOver30kw"></app-producers-summary>
  </section>

  <section>
    <app-storages-summary [storages]="feederContract.storages"></app-storages-summary>
  </section>

  <section>
    <app-pv-modules-summary [pvModules]="feederContract.pvModules"></app-pv-modules-summary>
  </section>

  <section>
    <app-show-compensation-categories
      [disable]="true"
      [feederContract]="feederContract"></app-show-compensation-categories>
  </section>
</div>
